/**
 * 錯誤處理攔截器
 * 負責處理 API 請求錯誤
 */
import { ApiError } from "../types";
import { logger } from "@/infrastructure/logger";

const log = logger.createLogger("apiErrorInterceptor");

/**
 * 處理 API 錯誤
 * @param response Fetch API 響應對象
 * @returns 處理後的錯誤對象
 */
export async function handleApiError(response: Response): Promise<never> {
  let errorData: any = {};

  try {
    // 嘗試解析錯誤響應為 JSON
    errorData = await response.json();
  } catch (e) {
    // 如果解析失敗，使用默認錯誤信息
    log.error("Failed to parse error response", e);
  }

  const message = errorData.message || `API 請求失敗: ${response.status}`;
  log.error(`API Error (${response.status}): ${message}`, errorData);

  throw new ApiError(message, response.status, errorData);
}
